import * as React from "react";
import {RootState} from "../../../../store/reducer/root/RootState";
import {connect} from "react-redux";
import SmsCenterDropdown from "./SmsCenterDropdown";
import {Icon} from "../../../../hiberUiKit/src/atoms/Icon/Icon";
import IconLarge from "../../../../hiberUiKit/src/atoms/Icon/IconLarge";
import Sms from "../../../../model/sms/Sms";
import "./smsCenterMenu.scss";

interface State {
	/**
	 * Is dropdown currently visible.
	 */
	dropDownVisible: boolean;
}

interface ReduxProps {
	/**
	 * SMS list.
	 */
	messages: Array<Sms>
}

class SmsCenterMenu extends React.PureComponent<ReduxProps, State> {
	constructor(props: ReduxProps) {
		super(props);
		this.state = {
			dropDownVisible: false,
		};
		this.toggleMenu = this.toggleMenu.bind(this);
		this.handleOutsideClick = this.handleOutsideClick.bind(this);
		this.onItemLinkClick = this.onItemLinkClick.bind(this);
	}

	/**
	 * Store dropdown and button elements.
	 */
	smsButton: HTMLElement = undefined;
	smsDropdown: HTMLDivElement = undefined;

	componentDidMount() {
		window.addEventListener("click", this.handleOutsideClick)
	}

	componentWillUnmount() {
		window.removeEventListener("click", this.handleOutsideClick)
	}

	render() {

		return (
			<div className={"c-sms-menu"}>
				<span className={"c-sms-menu_icon"}
					  ref={(elem) => this.smsButton = elem}
					  onClick={this.toggleMenu}>
					<IconLarge icon={Icon.SMS} variant={"white"}/>
				</span>
				{this.state.dropDownVisible &&
				<div className={"c-sms-menu_dropdown"}
					 ref={(elem) => this.smsDropdown = elem}>
					<SmsCenterDropdown
						messages={this.props.messages}
						onItemLinkClick={this.onItemLinkClick}
						isOpen={this.state.dropDownVisible}/>
				</div>
				}
			</div>
		);
	}

	/**
	 * Toggle dropdown.
	 */
	toggleMenu() {
		this.setState({dropDownVisible: !this.state.dropDownVisible});
	}

	/**
	 * On item click handler. Close dropdown on Link click.
	 */
	onItemLinkClick() {
		this.setState({dropDownVisible: false});
	}

	/**
	 * Handle click outside the drop down menu and 'bell' button.
	 * If click target not contains stored button and dropdown, this means click was targeted outside dropdown and button
	 * - then hide dropdown.
	 */
	handleOutsideClick(evt: Event) {
		if (this.state.dropDownVisible && !this.smsButton.contains(evt.target as Node) &&
			!this.smsDropdown.contains(evt.target as Node))
			this.setState({dropDownVisible: false});
	}
}

function mapStateToProps(state: RootState) {
	return {
		messages: state.sms.textMessages.getOrElse([])
	};
}

export default connect(mapStateToProps)(SmsCenterMenu);

